import ResourceLabel from './ResourceLabel';

export { ResourceLabel };
